import axios from 'axios';
import accessLocalStorage from './accessLocalStorage';
import { frontendLegacyOf, tecTenantAllows, tenantNodes } from '../constants/featureCatalog';

const getStored = () => {
  try {
    return accessLocalStorage.getUserLocalStorage();
  } catch (_) {
    return null;
  }
};

const getUser = () => {
  const stored = getStored();
  return stored && stored.user ? stored.user : null;
};

export const getRole = () => {
  const user = getUser();
  return user ? user.role : null;
};

export const getGrants = () => {
  const user = getUser();
  if (!user) return undefined;
  return user.enabled_modules;
};

export const hasFeature = (key, action = 'view') => {
  const role = getRole();
  if (!role) return false;
  if (role === 'root') return true;
  if (key.startsWith('troubleshooting.') || key.startsWith('system.')) return false;
  const legacy = frontendLegacyOf(key);
  if (action === 'view' && legacy === 'authenticated') return true;
  if (Array.isArray(legacy) && !key.startsWith('config.')) return action === 'view' && legacy.includes(role);
  if (role !== 'tec_tenant') return false;
  if (!key.startsWith('config.')) return false;
  const grants = getGrants();
  if (grants == null) return tecTenantAllows(key, action);
  const actions = grants[key];
  return Array.isArray(actions) && actions.includes(action);
};

export const hasAnyConfigView = () => {
  const role = getRole();
  if (role === 'root') return true;
  if (role !== 'tec_tenant') return false;
  return tenantNodes().some((node) => node.key.startsWith('config.') && hasFeature(node.key, 'view'));
};

export const refreshPermissions = async () => {
  const stored = getStored();
  if (!stored || !stored.user || !stored.token || !stored.ipRequest) return stored;
  try {
    const response = await axios.get(`${stored.ipRequest}api/login/me/permissions`, {
      headers: { Authorization: stored.token },
    });
    if (response && response.data) {
      const current = getStored();
      if (!current || !current.user || current.token !== stored.token) return current;
      const next = {
        ...current,
        user: {
          ...current.user,
          enabled_modules: response.data.enabled_modules,
          role: response.data.role || current.user.role,
        },
      };
      accessLocalStorage.setUserLocalStorage(next);
      return next;
    }
  } catch (_) {
    return stored;
  }
  return stored;
};
